import angular from 'angular';
import moment from 'moment';
import { TipoBeneficios, TipoBeneficiosEnum } from '../../beneficios.enum';
import { TrabalhadoresService } from '../../../../trabalhadores.service';
import { PlanosModalService } from '../../modal/planos/planos.modal.service';
import { ISuspensaoBeneficioGet } from '../../model/suspensao.model';

export class MeurhBeneficiosSuspensaoFormController {

    static $inject = [
        '$scope',
        'PlanosModalService',
        'TrabalhadoresService'
    ];

    public tipoBeneficio: TipoBeneficiosEnum;
    public limitDate: Date | string;
    public entity: ISuspensaoBeneficioGet;
    public form: angular.IFormController;
    public editable = false;

    public tiposDeBeneficiosConst = TipoBeneficios;
    public nomeBeneficiario: string;
    public limitEndDate: Date | string;
    public busy = false;

    constructor(
        public $scope: angular.IScope,
        public PlanosModalService: PlanosModalService,
        public TrabalhadoresService: TrabalhadoresService
    ) {}

    $onInit() {
        if (!this.editable) {
            this.setBeneficiario();
        } else {
            this.validateDataInicioSuspensao();
        }
    }

    setBeneficiario() {
        if (!this.entity.dependentetrabalhador?.dependentetrabalhador) {
            this.nomeBeneficiario = this.entity.trabalhador.nome + ' (Titular)';
            return;
        }
        this.nomeBeneficiario = this.entity.dependentetrabalhador.nome + ' (Dependente)';
    }

    validateDataInicioSuspensao() {
        this.$scope.$watch('$ctrl.entity.datainiciosuspensao', (newValue?: string, oldValue?: string) => {
            if (newValue !== oldValue) {
                this.resetDataFinalSuspensao(newValue);
            }
        }, true);
    }

    resetDataFinalSuspensao(value?: string) {
        this.entity.datafinalsuspensao = '';
        this.limitEndDate = this.setLimitEndDate(value);
    }

    setLimitEndDate(value?: string) {
        if (!value || value === '') {
            return '';
        }
        return moment(value).add(1, 'day').format('YYYY-MM-DD');
    }

    openPlanosModal() {
        const modal = this.PlanosModalService.open({
            beneficio: this.entity.beneficio,
            tipoBeneficio: this.tipoBeneficio,
            editable: this.editable
        });
        modal.result.then((response) => {
            this.entity.beneficio = response;
        }).catch(() => {/**/});
    }

}
